import { AutoCompleteOptionType } from "../../types"
import { autoCompleteStyles, inputCustomStyles } from "../../styles"
import { cx } from "@emotion/css"
import { useI18n } from "providers/I18n"
import AutoCompleteInput from "../SharedComponents/AutoComplete"
import { useMemo } from "react"

type Props = {
  marketParam: string
}

const defaultValues = {
  name: "All",
  code: "All",
}

export function FilterMarketFiltered({ marketParam }: Props) {
  const { t } = useI18n()

  const value = useMemo(() => {
    switch (marketParam) {
      case marketParam:
        return { name: marketParam, code: marketParam }

      default:
        return defaultValues
    }
  }, [marketParam])

  return (
    <AutoCompleteInput<AutoCompleteOptionType>
      id="market"
      name="market"
      label={t("revenue.filter.market")}
      autoComplete="off"
      value={value}
      options={[]}
      renderOption={(option) => <span>{option?.name}</span>}
      getOptionLabel={(option) => option?.name}
      getOptionSelected={(opt, val) => opt === val}
      disabled={true}
      classes={{
        ...autoCompleteStyles,
        inputRoot: cx(
          marketParam === "All"
            ? inputCustomStyles.grey
            : inputCustomStyles.blue,
          inputCustomStyles.inputRoot,
        ),
      }}
    />
  )
}
